import mock from './mock';

const permission = {
  setPermissionGroups: {
    desc: '保存授权组',
    method: 'post',
    url: 'api/v1/permissions',
    mock: true,
    request: {},
    response: mock.getGroups,
  },
};

export default permission;
